import AdjustIcon from '@mui/icons-material/LibraryBooks';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PeopleIcon from '@mui/icons-material/People';
import WorkIcon from '@mui/icons-material/Work';
import { HiOutlineCurrencyDollar } from 'react-icons/hi';
export const getCWJobsCandidateDetails = (candidate) => [
  {
    icon: <LocationOnIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `${candidate.CurrentLocation}`,
    tooltip: 'Current Location',
  },
  {
    icon: <WorkIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Job Title :${candidate.DesiredJobTitle ? candidate.DesiredJobTitle : 'N/A'}`,
    tooltip: 'Job Title',
  },
  {
    icon: <PeopleIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Experience: ${candidate.WorkExperience ? candidate.WorkExperience : 'N/A'}`,
    tooltip: 'Experience',
  },
  {
    icon: <HiOutlineCurrencyDollar color="#888A8E" size="1.27rem" />,
    label: candidate.CurrentSalary
      ? `Current Salary: ${candidate.CurrentSalary?.LowerValue && ''} ${
          candidate.CurrentSalary?.UpperValue
        } | Rate Type: ${candidate.CurrentSalary?.RateType}`
      : 'Current Salary: N/A',
    tooltip: 'Current Salary',
  },
  {
    icon: <HiOutlineCurrencyDollar color="#888A8E" size="1.27rem" />,
    label: candidate.DesiredSalary
      ? `Desired Salary:  ${candidate.DesiredSalary?.LowerValue && ''} ${
          candidate.DesiredSalary?.UpperValue
        } | Rate Type: ${candidate.DesiredSalary?.RateType}`
      : 'Desired Salary: N/A',
    tooltip: 'Desired Salary',
  },
  {
    icon: <AdjustIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Willing to Relocate: ${candidate.DesiredLocations}`,
    tooltip: 'Willing to Relocate',
  },
];

export const searchTypeOptions = [
  {
    label: 'Job Title',
    value: 'JobTitle',
  },
  {
    label: 'Profile and CV',
    value: 'ProfileAndCV',
  },
];
export const searchOptionOptions = [
  {
    label: 'Smart Serch',
    value: 'SmartSearch',
  },
  {
    label: 'Profile and CV',
    value: 'ProfileAndCV',
  },
];

export const salaryRateTypeOptions = [
  {
    label: 'Annual Salary',
    value: 'Annual Salary',
  },
  {
    label: 'Daily Rate',
    value: 'Daily Rate',
  },
  {
    label: 'Hourly Rate',
    value: 'Hourly Rate',
  },
];

export const languagesCheckBoxOptions = {
  Albanian: 'Albanian',
  Arabic: 'Arabic',
  'Arabic (N. African)': 'Arabic(N.African)',
  Asturian: 'Asturian',
  Basque: 'Basque',
  Bengali: 'Bengali',
  Berber: 'Berber',
  Breton: 'Breton',
  Bulgarian: 'Bulgarian',
  Cantonese: 'Cantonese',
  Catalan: 'Catalan',
  Cornish: 'Cornish',
  Corsican: 'Corsican',
  Croatian: 'Croatian',
  Czech: 'Czech',
  Danish: 'Danish',
  Dutch: 'Dutch',
  English: 'English',
  Esperanto: 'Esperanto',
  Estonian: 'Estonian',
  Faroese: 'Faroese',
  Farsi: 'Farsi',
  Finnish: 'Finnish',
  'Franco-provençal': 'Franco-provençal',
  French: 'French',
  Frisian: 'Frisian',
  Friulian: 'Friulian',
  Gaelic: 'Gaelic',
  Galician: 'Galician',
  German: 'German',
  Greek: 'Greek',
  Greenlandic: 'Greenlandic',
  Gujarati: 'Gujarati',
  Hebrew: 'Hebrew',
  Hindi: 'Hindi',
  Hungarian: 'Hungarian',
  Icelandic: 'Icelandic',
  Igbo: 'Igbo',
  Irish: 'Irish',
  Italian: 'Italian',
  Japanese: 'Japanese',
  Kurdish: 'Kurdish',
  Ladin: 'Ladin',
  Latin: 'Latin',
  Latvian: 'Latvian',
  Lithuanian: 'Lithuanian',
  Luxembourgian: 'Luxembourgian',
  Macedonian: 'Macedonian',
  Malay: 'Malay',
  Maltese: 'Maltese',
  Mandarin: 'Mandarin',
  'Manx Gaelic': 'ManxGaelic',
  Mirandese: 'Mirandese',
  Moluccan: 'Moluccan',
  Moroccan: 'Moroccan',
  None: 'None',
  Norwegian: 'Norwegian',
  Occitan: 'Occitan',
  Other: 'Other',
  Papiamento: 'Papiamento',
  Polish: 'Polish',
  Portuguese: 'Portuguese',
  Punjabi: 'Punjabi',
  'Rhaeto-Romanic': 'Rhaeto-Romanic',
  Romanian: 'Romanian',
  Russian: 'Russian',
  Sámi: 'Sámi',
  Sardinian: 'Sardinian',
  'Scottish Gaelic': 'ScottishGaelic',
  Serbian: 'Serbian',
  'Serbo Croat': 'SerboCroat',
  Slovak: 'Slovak',
  Slovakian: 'Slovakian',
  Slovenian: 'Slovenian',
  Somalian: 'Somalian',
  Sora: 'Sora',
  Spanish: 'Spanish',
  Surinamese: 'Surinamese',
  Swedish: 'Swedish',
  Tamil: 'Tamil',
  Thai: 'Thai',
  Turkish: 'Turkish',
  Urdu: 'Urdu',
  Vietnamese: 'Vietnamese',
  Walachian: 'Walachian',
  Welsh: 'Welsh',
};
export const highestLevelOfEducationCheckBoxOptions = {
  'A levels /advanced GNVQ': 'A levels /advanced GNVQ',
  BTEC: 'BTEC',
  'City &amp; Guilds': 'City &amp; Guilds',
  Diploma: 'Diploma',
  'GCSE/GNVQ/O levels': 'GCSE/GNVQ/O levels',
  'HND/HNC': 'HND/HNC',
  'Masters degree or higher': 'Masters degree or higher',
  PhD: 'PhD',
  'Senior business or technical qualification': 'Senior business or technical qualification',
  'University degree': 'University degree',
};

export const countriesCheckBoxOptions = {
  Afghanistan: 'Afghanistan',
  Albania: 'Albania',
  Algeria: 'Algeria',
  Andorra: 'Andorra',
  Angola: 'Angola',
  Anguilla: 'Anguilla',
  'Antigua &amp; Barbuda': 'Antigua &amp; Barbuda',
  Argentina: 'Argentina',
  Armenia: 'Armenia',
  Aruba: 'Aruba',
  Australia: 'Australia',
  Austria: 'Austria',
  Azerbaijan: 'Azerbaijan',
  Bahamas: 'Bahamas',
  Bahrain: 'Bahrain',
  Bangladesh: 'Bangladesh',
  Barbados: 'Barbados',
  Belarus: 'Belarus',
  Belgium: 'Belgium',
  Belize: 'Belize',
  Benin: 'Benin',
  Bermuda: 'Bermuda',
  Bhutan: 'Bhutan',
  Bolivia: 'Bolivia',
  'Bosnia &amp; Herzegovinia': 'Bosnia &amp; Herzegovinia',
  Botswana: 'Botswana',
  Brazil: 'Brazil',
  Brunei: 'Brunei',
  Bulgaria: 'Bulgaria',
  'Burkina Faso': 'Burkina Faso',
  Burma: 'Burma',
  Burundi: 'Burundi',
  Cambodia: 'Cambodia',
  Cameroon: 'Cameroon',
  Canada: 'Canada',
  'Cape Verde': 'Cape Verde',
  'Cayman Islands': 'Cayman Islands',
  'Central African Republic': 'Central African Republic',
  Chad: 'Chad',
  Chile: 'Chile',
  China: 'China',
  'Christmas Island': 'Christmas Island',
  Colombia: 'Colombia',
  'Comoro Islands': 'Comoro Islands',
  Comoros: 'Comoros',
  'Congo, Democratic Republic of': 'Congo, Democratic Republic of',
  'Costa Rica': 'Costa Rica',
  Croatia: 'Croatia',
  Cuba: 'Cuba',
  Cyprus: 'Cyprus',
  'Czech Republic': 'Czech Republic',
  Denmark: 'Denmark',
  Djibouti: 'Djibouti',
  Dominica: 'Dominica',
  'Dominican Republic': 'Dominican Republic',
  'East Timor': 'East Timor',
  Ecuador: 'Ecuador',
  Egypt: 'Egypt',
  'El Salvador': 'El Salvador',
  'El Savador': 'El Savador',
  'Equatorial Guinea': 'Equatorial Guinea',
  Eritrea: 'Eritrea',
  Estonia: 'Estonia',
  Ethiopia: 'Ethiopia',
  'Falkland Islands': 'Falkland Islands',
  Fiji: 'Fiji',
  Finland: 'Finland',
  France: 'France',
  'French Guiana': 'French Guiana',
  'French Polynesia': 'French Polynesia',
  Gabon: 'Gabon',
  Gambia: 'Gambia',
  Georgia: 'Georgia',
  Germany: 'Germany',
  Ghana: 'Ghana',
  Gibraltar: 'Gibraltar',
  Greece: 'Greece',
  Greenland: 'Greenland',
  Grenada: 'Grenada',
  Guadeloupe: 'Guadeloupe',
  Guam: 'Guam',
  Guatemala: 'Guatemala',
  Guinea: 'Guinea',
  'Guinea-Bissau': 'Guinea-Bissau',
  Guyana: 'Guyana',
  Haiti: 'Haiti',
  'Heard Island &amp; McDonald Islands': 'Heard Island &amp; McDonald Islands',
  Honduras: 'Honduras',
  'Hong Kong': 'Hong Kong',
  Hungary: 'Hungary',
  Iceland: 'Iceland',
  India: 'India',
  Indonesia: 'Indonesia',
  Iran: 'Iran',
  Iraq: 'Iraq',
  Israel: 'Israel',
  Italy: 'Italy',
  Jamaica: 'Jamaica',
  Japan: 'Japan',
  Jordan: 'Jordan',
  Kazakhstan: 'Kazakhstan',
  Kenya: 'Kenya',
  Kiribati: 'Kiribati',
  Kuwait: 'Kuwait',
  Kyrgyzstan: 'Kyrgyzstan',
  Laos: 'Laos',
  Latvia: 'Latvia',
  Lebanon: 'Lebanon',
  Lesotho: 'Lesotho',
  Liberia: 'Liberia',
  Libya: 'Libya',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lithuania',
  Luxembourg: 'Luxembourg',
  'Macedonia, FYR of': 'Macedonia, FYR of',
  Madagascar: 'Madagascar',
  Madegascar: 'Madegascar',
  Malawi: 'Malawi',
  Malaysia: 'Malaysia',
  Maldives: 'Maldives',
  Mali: 'Mali',
  Malta: 'Malta',
  'Marshall Islands': 'Marshall Islands',
  Martinique: 'Martinique',
  Mauritania: 'Mauritania',
  Mauritius: 'Mauritius',
  Mayotte: 'Mayotte',
  Mexico: 'Mexico',
  Moldova: 'Moldova',
  Monaco: 'Monaco',
  Mongolia: 'Mongolia',
  Montenegro: 'Montenegro',
  Montserrat: 'Montserrat',
  Morocco: 'Morocco',
  Mozambique: 'Mozambique',
  Namibia: 'Namibia',
  Nauru: 'Nauru',
  Nepal: 'Nepal',
  Netherlands: 'Netherlands',
  'Netherlands Antilles': 'Netherlands Antilles',
  'New Caledonia': 'New Caledonia',
  'New Zealand': 'New Zealand',
  Nicaragua: 'Nicaragua',
  Niger: 'Niger',
  Nigeria: 'Nigeria',
  Niue: 'Niue',
  'Norfolk Island': 'Norfolk Island',
  'North Korea': 'North Korea',
  'Northern Mariana Islands': 'Northern Mariana Islands',
  Norway: 'Norway',
  Oman: 'Oman',
  Pakistan: 'Pakistan',
  Palau: 'Palau',
  Palestine: 'Palestine',
  Panama: 'Panama',
  'Papua New Guinea': 'Papua New Guinea',
  Paraguay: 'Paraguay',
  Peru: 'Peru',
  Philippines: 'Philippines',
  Pitcairn: 'Pitcairn',
  Poland: 'Poland',
  Portugal: 'Portugal',
  'Puerto Rico': 'Puerto Rico',
  Qatar: 'Qatar',
  'Republic of Ireland': 'Republic of Ireland',
  Romania: 'Romania',
  Russia: 'Russia',
  Rwanda: 'Rwanda',
  'Saint Helena': 'Saint Helena',
  'Saint Pierre and Miquelon': 'Saint Pierre and Miquelon',
  Samoa: 'Samoa',
  'San Marino': 'San Marino',
  'Sao Tome and Principe': 'Sao Tome and Principe',
  'Saudi Arabia': 'Saudi Arabia',
  Senegal: 'Senegal',
  Serbia: 'Serbia',
  Seychelles: 'Seychelles',
  'Sierra Leone': 'Sierra Leone',
  Singapore: 'Singapore',
  Slovakia: 'Slovakia',
  Slovenia: 'Slovenia',
  'Solomon Islands': 'Solomon Islands',
  Somalia: 'Somalia',
  'South Africa': 'South Africa',
  'South Korea': 'South Korea',
  Spain: 'Spain',
  'Sri Lanka': 'Sri Lanka',
  'St Kitts &amp; Nevis': 'St Kitts &amp; Nevis',
  'St Lucia': 'St Lucia',
  'St Vincent &amp; the Grenadines': 'St Vincent &amp; the Grenadines',
  Sudan: 'Sudan',
  Suriname: 'Suriname',
  'Svalbard and Jan Mayen Islands': 'Svalbard and Jan Mayen Islands',
  Swaziland: 'Swaziland',
  Sweden: 'Sweden',
  Switzerland: 'Switzerland',
  Syria: 'Syria',
  Taiwan: 'Taiwan',
  Tajikistan: 'Tajikistan',
  Tanzania: 'Tanzania',
  Tatarstan: 'Tatarstan',
  Thailand: 'Thailand',
  Togo: 'Togo',
  Tokelau: 'Tokelau',
  Tonga: 'Tonga',
  'Trinidad &amp; Tobago': 'Trinidad &amp; Tobago',
  Tunisia: 'Tunisia',
  Turkey: 'Turkey',
  Turkmenistan: 'Turkmenistan',
  'Turks and Caicos': 'Turks and Caicos',
  Tuvalu: 'Tuvalu',
  Uganda: 'Uganda',
  UK: 'UK',
  Ukraine: 'Ukraine',
  'United Arab Emirates': 'United Arab Emirates',
  'United States': 'United States',
  Uruguay: 'Uruguay',
  Uzbekistan: 'Uzbekistan',
  Vanuatu: 'Vanuatu',
  Venezuela: 'Venezuela',
  Vietnam: 'Vietnam',
  'Virgin Islands': 'Virgin Islands',
  Yemen: 'Yemen',
  Zambia: 'Zambia',
  Zimbabwe: 'Zimbabwe',
};

export const jobHoursOptions = [
  {
    label: 'Full Time',
    value: 'Full Time',
  },
  {
    label: 'Part Time',
    value: 'Part Time',
  },
];

export const HideCandidatesViewedSinceOptions = [
  {
    label: '3 Days',
    value: '3 Days',
  },
  {
    label: '5 Days',
    value: '5 Days',
  },
  {
    label: '7 Days',
    value: '7 Days',
  },
  {
    label: 'Today',
    value: 'Today',
  },
  {
    label: 'Yesterday',
    value: 'Yesterday',
  },
];

export const relocateOptions = [
  {
    label: 'Yes',
    value: '1',
  },
  {
    label: 'No',
    value: '0',
  },
];
